document.addEventListener("DOMContentLoaded", function() {

    const currencyButton = document.querySelector('.btn-more-currencies-strip');
    const ratesList = document.querySelector('.rates-strip-list');

    if (currencyButton && ratesList) {
        currencyButton.addEventListener('click', function(e) {
            e.preventDefault();

            ratesList.classList.toggle('collapsed');
            this.classList.toggle('expanded');

            const buttonText = this.querySelector('span');
            if (buttonText) {
                const translations = window.CURRENCY_RATES_CONFIG?.translations || {};
                if (ratesList.classList.contains('collapsed')) {
                    buttonText.textContent = translations.show_more || 'Pozostałe waluty';
                } else {
                    buttonText.textContent = translations.show_less || 'Zwiń waluty';
                }
            }

            const arrow = this.querySelector('.arrow-toggle');
            if (arrow) {
                arrow.style.transform = ratesList.classList.contains('collapsed') ?
                    'rotate(0deg)' : 'rotate(180deg)';
            }
        });
    }

    function formatNumber4(num) {
        return parseFloat(num).toFixed(4);
    }

    function formatNumber2(num) {
        return parseFloat(num).toFixed(2);
    }

    function loadCurrencyRates() {
        const rateItems = document.querySelectorAll('.rates-strip-item');

        fetch('/ajax', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: 'getExchangeRates=1'
        })
            .then(response => response.json())
            .then(data => {
                rateItems.forEach(item => {
                    const currency = item.getAttribute('data-currency');
                    if (data[currency]) {
                        const currencyData = data[currency];

                        const buyRate = item.querySelector('.buy-rate .rate-num');
                        if (buyRate) {
                            buyRate.textContent = formatNumber4(currencyData.buy);
                        }

                        const sellRate = item.querySelector('.sell-rate .rate-num');
                        if (sellRate) {
                            sellRate.textContent = formatNumber4(currencyData.sell);
                        }

                        const buyChange = currencyData.buyChange || 0;
                        const saleChange = currencyData.saleChange || 0;

                        const buyArrow = item.querySelector('.buy-rate .rate-arrow');
                        if (buyArrow) {
                            updateArrow(buyArrow, buyChange);
                        }

                        const sellArrow = item.querySelector('.sell-rate .rate-arrow');
                        if (sellArrow) {
                            updateArrow(sellArrow, saleChange);
                        }

                        const buyRateElement = item.querySelector('.buy-rate');
                        if (buyRateElement) {
                            buyRateElement.classList.remove('up', 'down', 'curr-operation-rate');
                            if (buyChange > 0) {
                                buyRateElement.classList.add('up', 'curr-operation-rate');
                            } else if (buyChange < 0) {
                                buyRateElement.classList.add('down', 'curr-operation-rate');
                            }
                        }

                        const sellRateElement = item.querySelector('.sell-rate');
                        if (sellRateElement) {
                            sellRateElement.classList.remove('up', 'down', 'curr-operation-rate');
                            if (saleChange > 0) {
                                sellRateElement.classList.add('up', 'curr-operation-rate');
                            } else if (saleChange < 0) {
                                sellRateElement.classList.add('down', 'curr-operation-rate');
                            }
                        }

                        const diffElement = item.querySelector('.rate-day-diff');
                        if (diffElement && currencyData.dayDiff !== undefined) {
                            let positive = '';
                            let clazz = 'neg';
                            if (currencyData.dayDiff >= 0) {
                                positive = '+';
                                clazz = 'pos';
                            }
                            diffElement.classList.remove('pos', 'neg');
                            diffElement.classList.add(clazz);
                            diffElement.textContent = positive + formatNumber4(currencyData.dayDiff) +
                                ' (' + positive + formatNumber2(currencyData.percent) + '%)';
                        }
                    }
                });
            })
            .catch(error => {
                console.error('Error loading currency rates:', error);
            });
    }

    function updateArrow(arrowElement, change) {
        if (!arrowElement) return;

        arrowElement.classList.remove('arrow-up', 'arrow-down', 'arrow-flat');

        if (change > 0) {
            arrowElement.src = '/assets/images/arrow_yellow_up.svg';
            arrowElement.alt = 'wzrost';
            arrowElement.classList.add('arrow-up');
        } else if (change < 0) {
            arrowElement.src = '/assets/images/arrow_blue_down.svg';
            arrowElement.alt = 'spadek';
            arrowElement.classList.add('arrow-down');
        } else {
            arrowElement.src = '/assets/images/dot.svg';
            arrowElement.alt = 'bez zmian';
            arrowElement.classList.add('arrow-flat');
        }
    }

    let ratesInterval = null;
    let stopTimeout = null;

    function startLiveRates() {
        if (ratesInterval) {
            clearInterval(ratesInterval);
        }
        if (stopTimeout) {
            clearTimeout(stopTimeout);
        }

        loadCurrencyRates();

        ratesInterval = setInterval(loadCurrencyRates, 15000);

        stopTimeout = setTimeout(function() {
            stopLiveRates();
        }, 30 * 60 * 1000);
    }

    function stopLiveRates() {
        if (ratesInterval) {
            clearInterval(ratesInterval);
            ratesInterval = null;
        }

        const ratesStrip = document.querySelector('.currency-rates-strip');
        if (ratesStrip) {
            ratesStrip.style.opacity = '0.5';
        }

        const restartBtn = document.getElementById('onlineRestart');
        if (restartBtn) {
            restartBtn.style.display = 'block';
            restartBtn.addEventListener('click', function() {
                this.style.display = 'none';
                if (ratesStrip) {
                    ratesStrip.style.opacity = '1';
                }
                startLiveRates();
            });
        }
    }

    if (document.querySelector('.currency-rates-strip')) {
        startLiveRates();
    }
});